import React from 'react'
import { Tooltip } from 'antd'
import { rightTickIcon, crossRedIcon, crossGreyIcon } from '../../assets/images'

const homeCollectionSchema = ({ data, headers }) => {
    return (
        <tr className='text-gray-600' >
            {headers.map((key) => {
                switch (key) {
                    case 'pincode_area':
                        return <td className='pl-3 pr-5 py-5'>{data?.hash_result?.pincode_area}</td>
                    case key:
                        return (
                            <td className='pl-3 pr-5 py-5'>
                                <Tooltip overlayClassName='w-60' title={data?.miss_data[key]?.supported === "Yes" ? "All services are available at this center"
                                    : !data?.miss_data[key]?.full_missing ? `Following services are not available at this center
                                        ${data?.miss_data[key]?.reason}` : 'Services are not available at this center'} trigger='hover'>
                                    <span >{data?.miss_data[key]?.supported === "Yes" ? <img src={rightTickIcon} /> :
                                        !data?.miss_data[key]?.full_missing ? <img src={crossGreyIcon} /> : <img src={crossRedIcon} />}</span>
                                </Tooltip>
                            </td>
                        )
                }
            })}
        </tr>
    )
}

export default homeCollectionSchema